import { Box, Typography, Hidden } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloseIcon from 'shared/components/Icon/CloseIcon';
import LearnMoreContent from '../LearnMoreContent/LearnMoreContent';
const { WARNING_TEXTBOX_BORDER } = COLORS;

const LearnMoreHeader = ({
  showWarning,
  handleWarningClick,
}: {
  showWarning: boolean;
  handleWarningClick: () => void;
}) => {
  return (
    <Box
      style={{
        display: 'flex',
        gap: '10px',
        // alignItems: 'center',
        fontSize: 12,
      }}
    >
      <InfoOutlinedIcon
        style={{ color: WARNING_TEXTBOX_BORDER }}
        onClick={() => (showWarning ? undefined : handleWarningClick())}
      />
      {!showWarning ? <Typography style={{ fontSize: 14 }}>Learn more</Typography> : <></>}
      <Hidden smDown>{showWarning ? <LearnMoreContent /> : <></>}</Hidden>
      {showWarning ? (
        <Box style={{ marginLeft: 'auto' }}>
          <CloseIcon fontSize="inherit" onClick={handleWarningClick} style={{ cursor: 'pointer' }} />
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default LearnMoreHeader;
